import React from 'react';
import { Box, Paper, Toolbar } from '@mui/material';

interface IContentLayoutProps {
    children: React.ReactNode | React.ReactNode[];
    isDesktop: boolean;
}

export function DAppContent({ children, isDesktop }: IContentLayoutProps) {
    return (
        <Box
            component="main"
            sx={{
                flexGrow: 1,
                height: '100vh',
                overflow: 'auto',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            {!isDesktop ? <Toolbar /> : null}
            <Paper
                sx={{
                    p: 2,
                    display: 'flex',
                    flex: 1,
                    flexDirection: 'column',
                    minHeight: 0,
                }}
            >
                {children}
            </Paper>
        </Box>
    );
}
